import { ReactNode, useEffect } from 'react';

// third-party
import { I18nextProvider } from 'react-i18next';

// project-imports
import useConfig from 'hooks/useConfig';
import i18n from 'i18n';

interface Props {
  children: ReactNode;
}

// ==============================|| LOCALIZATION ||============================== //

export default function Locales({ children }: Props) {
  const {
    state: { i18n: lang }
  } = useConfig();

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
